import Carousel from 'react-bootstrap/Carousel';
import photo1 from './../../photos/slid1.jpg';
import photo2 from './../../photos/slid2.jpg';
import photo3 from './../../photos/slid1.jpg';
import { Container, Row } from 'react-bootstrap';


function Slider(){
    return(
        <section id='slider-section'>
            <Container>
                <Row>
                <h3>
                Testimonials
                </h3>
                </Row>
                <Row>
                <Carousel style={{backgroundColor:'white' ,borderRadius:'15px' ,padding:"50px" }}>
                    <Carousel.Item>
                        <img
                        src={photo2}
                        alt="Second slide"
                        />
                        <Carousel.Caption>
                            <h4>Maccy Doe - Front End</h4>
                            <p>"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. "</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        src={photo3}
                        alt="Third slide"
                        />
                    <Carousel.Caption>
                        <h4>Simab Dave - Web Designer</h4>
                        <p>
                        "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live."
                        </p>
                    </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>
                </Row>
            </Container>
        </section>
  );
}

export default Slider;